export const TextSection = ({
  title = "",
  content = "",
  contentNext = "",
  children,
  className,
}) => {
  return (
    <section
      className={
        className ??
        "w-full py-28 px-6 md:px-10 flex justify-center mt-6 mb-5 text-justify"
      }
    >
      <div
        className="w-full mx-auto flex flex-col gap-8"
        style={{ maxWidth: "750px" }}
      >
        {title && (
          <h2 className="text-center w-full text-2xl md:text-3xl font-bold uppercase mb-6">
            {title}
          </h2>
        )}

        <div className="text-gray-400 flex flex-col gap-6">
          {content && (
            <p className="leading-relaxed text-base md:text-lg text-justify">
              {content}
            </p>
          )}

          {contentNext && (
            <p className="leading-relaxed text-base md:text-lg text-justify">
              {contentNext}
            </p>
          )}

          {children && (
            <div className=" w-full text-justify mt-5">{children}</div>
          )}
        </div>
      </div>
    </section>
  );
};
